const css = `.jcZFlG__tableBodyRow td:first-of-type{padding-left:0}.jcZFlG__tableBodyRow td:last-of-type{padding-right:0}.jcZFlG__tableBodyRow.jcZFlG__highlight:hover td{background-color:var(--base-surfaces-hover)}.jcZFlG__tableBodyRow.jcZFlG__clickable:hover td{cursor:pointer}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"tableBodyRow":"jcZFlG__tableBodyRow","highlight":"jcZFlG__highlight","clickable":"jcZFlG__clickable"};
